import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import GiftCardThumb from '@/components/GiftCardThumb';
import { useCart } from '@/lib/cartContext';
import { formatPrice } from '@/lib/format';

export default function CartDrawer() {
  const { items, isOpen, setIsOpen, removeItem, total, count } = useCart();

  return (
    <>
      <div className={`fixed inset-0 bg-foreground/40 z-50 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={() => setIsOpen(false)} aria-hidden="true" />
      <aside role="dialog" aria-modal="true" aria-label="Karfa" className={`fixed top-0 right-0 h-full w-full max-w-md bg-background z-50 shadow-2xl flex flex-col transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between px-6 py-5 border-b border-border">
          <div>
            <h3 className="font-heading text-2xl text-primary">Karfan</h3>
          </div>
          <button onClick={() => setIsOpen(false)} aria-label="Loka körfu" className="p-2 hover:text-accent"><X className="w-5 h-5" /></button>
        </div>

        <div className="flex-1 overflow-y-auto px-4 sm:px-6 py-4">
          {items.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center text-center gap-3 text-muted-foreground">
              <p className="font-mono text-xs uppercase tracking-widest">Karfan er tóm</p>
              <p className="font-heading text-xl text-primary">Engar treyjar valdar</p>
              <Link to="/safnid" onClick={() => setIsOpen(false)} className="mt-2 font-mono text-[11px] uppercase tracking-widest text-accent underline">Skoða safnið</Link>
            </div>
          ) : (
            <ul className="divide-y divide-border">
              {items.map((it) => (
                <li key={`${it.product_id}-${it.size}`} className="py-4 flex gap-4">
                  {it.type === 'gift_card'
                    ? <GiftCardThumb amount={it.price} />
                    : <Link to={`/vara/${it.product_id}`} onClick={() => setIsOpen(false)} className="w-20 h-24 bg-card overflow-hidden flex-shrink-0"><img src={it.image} alt={it.name} loading="lazy" className="w-full h-full object-cover" /></Link>}
                  <div className="flex-1 min-w-0">
                    {it.type === 'gift_card'
                      ? <span className="font-heading text-base text-primary leading-tight block">{it.name}</span>
                      : <Link to={`/vara/${it.product_id}`} onClick={() => setIsOpen(false)} className="font-heading text-base text-primary leading-tight hover:text-accent transition-colors block">{it.name}</Link>}
                    <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-0.5">{it.type === 'gift_card' ? 'Sent í tölvupósti eftir greiðslu' : `${it.team} · Stærð ${it.size}`}</p>
                    <div className="flex items-center justify-between mt-3">
                      <span className="font-mono text-sm">{formatPrice(it.price)}</span>
                      <button onClick={() => removeItem(it.product_id, it.size)} className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground hover:text-accent">Fjarlægja</button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-border px-4 sm:px-6 py-4 sm:py-5 space-y-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
            <div className="flex justify-between font-body text-sm"><span>Samtals</span><span className="font-bold">{formatPrice(total)}</span></div>
            <Link to="/karfan" onClick={() => setIsOpen(false)} className="block w-full bg-primary text-primary-foreground text-center py-4 font-mono text-xs uppercase tracking-[0.2em] hover:opacity-90">Ganga frá kaupum</Link>
            <Link to="/safnid" onClick={() => setIsOpen(false)} className="block w-full border border-primary text-primary text-center py-3 font-mono text-xs uppercase tracking-widest hover:bg-card">Halda áfram að versla</Link>
            <p className="font-mono text-[10px] text-muted-foreground text-center uppercase tracking-widest">{count} atriði</p>
          </div>
        )}
      </aside>
    </>
  );
}